import {
    ingestMediaFromUrl,
    isStoredMediaUrl,
    resolveMediaUrlForSave,
    type MediaScope,
} from '../services/mediaService';

export async function resolveChefImageUrlForSave(
    chefId: string,
    url: string | undefined,
    previousUrl?: string,
): Promise<string | undefined> {
    const result = await resolveMediaUrlForSave('chef_image', url, previousUrl, { chefId });
    return result.url;
}

export async function ingestChefProfilePicUrl(
    chefId: string,
    profilePicUrl: string | undefined,
    currentImageUrl?: string,
): Promise<string | undefined> {
    const trimmed = profilePicUrl?.trim();
    if (!trimmed) {
        return currentImageUrl;
    }

    if (isStoredMediaUrl(currentImageUrl) && currentImageUrl) {
        return currentImageUrl;
    }

    try {
        const ingested = await ingestMediaFromUrl('chef_image', trimmed, { chefId });
        return ingested.readUrl;
    } catch (error) {
        console.error('Failed to ingest chef profile image, using source URL', error);
        return trimmed;
    }
}

export { isStoredMediaUrl };
